import React from "react";
import TextInput from "../../input/text-input";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { useComponentBackgroundColor } from "../../common/adaptive-theme-provider";
import { Typography } from "@mhome/ui";

const TextDetail1Widget = ({ widget, onValueUpdate, pattern }) => {
  const getComponentBgColor = useComponentBackgroundColor();

  const handleValueUpdate = (data) => {
    const updatedWidget = { ...widget, value: data.toString() };
    onValueUpdate(updatedWidget);
  };

  const disabled = pattern && pattern.endsWith("_R");
  const showWarning = pattern && pattern.endsWith("_W");

  return (
    <div className="w-full flex flex-col">
      {/* Text Controls Section */}
      <div
        className="flex flex-col rounded-2xl"
        style={{
          padding: "12px",
          backgroundColor: getComponentBgColor("hsl(var(--card))"),
        }}
      >
        <Typography className="mb-3 font-bold flex items-center gap-1 text-sm">
          {widget?.description ? widget.description : "Text"}
          {showWarning && (
            <SyncProblemIcon
              fontSize="inherit"
              style={{ color: "hsl(var(--warning))" }}
            />
          )}
        </Typography>

        <div
          className="flex items-stretch w-full"
          style={{ minHeight: 0, height: "auto" }}
        >
          {widget && (
            <TextInput
              valueSpec={widget}
              onChange={handleValueUpdate}
              style="standard"
              maxHeight="200px"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TextDetail1Widget;
